import { InterventionJson } from './types/models';

export function monthYear(intervention: InterventionJson): string {
  if (!intervention.timestamp) {
    return '';
  }
  const d = Date.parse(intervention.timestamp);
  let month = '';
  let year = '';
  try {
    month = new Intl.DateTimeFormat('fr', { month: 'long' }).format(d);
    year = new Intl.DateTimeFormat('fr', { year: 'numeric' }).format(d);
  } catch (error) {
    console.log(error);
  }
  return `${month} ${year}`;
}
